import { render, staticRenderFns } from "./MoveQuestionsModal.vue?vue&type=template&id=42738e32&scoped=true&"
import script from "./MoveQuestionsModal.vue?vue&type=script&lang=js&"
export * from "./MoveQuestionsModal.vue?vue&type=script&lang=js&"
import style0 from "./MoveQuestionsModal.vue?vue&type=style&index=0&id=42738e32&lang=scss&scoped=true&"
import style1 from "./MoveQuestionsModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42738e32",
  null
  
)

export default component.exports